import React from 'react';
import Checkbox from '../../../../components/ui/Checkbox';
import { ChatAvatar } from './ChatAvatar';
import { cn } from '@/lib/utils';
import type { ChatContactPickItem } from '../../lib/chatContactPicker';

interface Props {
    item: ChatContactPickItem;
    selected: boolean;
    onSelect: (key: string) => void;
}

export const ChatContactPickRow: React.FC<Props> = ({ item, selected, onSelect }) => (
    <li
        role="option"
        aria-selected={selected}
        tabIndex={0}
        onClick={() => onSelect(item.key)}
        onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelect(item.key);
            }
        }}
        className={cn(
            'flex w-full cursor-pointer items-center gap-s3 px-s4 py-s3 text-left',
            'hover:bg-surface-subtle focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary/30',
            selected && 'bg-primary-subtle',
        )}
    >
        <Checkbox
            checked={selected}
            readOnly
            tabIndex={-1}
            aria-hidden
            checkboxSize="sm"
            containerClassName="pointer-events-none shrink-0"
        />
        <ChatAvatar
            name={item.fullName}
            avatar={item.avatarUrl || undefined}
            size="lg"
            showChannelIcon={false}
            fallbackType="icon"
        />
        <span className="min-w-0 flex-1">
            <span className="block truncate text-md font-medium text-secondary">{item.fullName}</span>
            <span className="block truncate font-mono text-sm text-muted">{item.phoneNumber}</span>
        </span>
    </li>
);
